

<td style="min-width: 3vw;">
  <app-article-image
    [useLazyLoad]="article.article_details ? false : true" [width]="'50px'"
    [imageUrl]="
      article.article_details ? article.article_details.thumbs[0] : ''
    "
    [articleType]="
      article.article_details ? article.article_details.article_type : 'P'
    "
    [hidden]="!article.article_details"
    [description]="''"
  ></app-article-image>
</td>
<td>
  <b>{{ article.quantity }} &times;</b>
  {{ article.article_code ? article.article_code : "" }}
</td>
<td class="text-wrap clickable" [articleQuickView]="article.article_code" style="min-width: 22.5vw;">
  {{ article.article_description ? article.article_description : ""
  }}<small class="d-block">{{ article.remarks }}</small>
  @if (article.battery_kind) {
    <small class="d-block">{{
      article.battery_kind.toString().toUpperCase() | translate
    }}</small>
  }
</td>
<td >
  <a [articleQuickView]="article.frame_number">{{ article.frame_number }}
  </a>
  @if (article.mileage) {
    <br/>{{article.mileage}} Km
  }
</td>
<td>
  @if (article.employee_name) {
    <span>{{ article.employee_name }}</span>
  }
</td>
<td>
  {{ descriptions[article.reason_type] | translate }}<br />
  @if (article.flow_type && article.flow_type !== 'regular') {
    <small>{{
      article.flow_type.toUpperCase() | translate
    }}</small>
  }
</td>
@if (showControls) {
  <td class="actions text-end">
    <a
      (click)="editArticle()"
      class="btn btn-sm btn-dark"
    >{{'EDIT' | translate}}</a> |
    <a class="text-danger"
      (click)="deleteArticle()"
    >{{'DELETE' | translate}}</a>
  </td>
}
